export const findSliderScale = (scale) => {
  let uiScale = 10;
  while (scale < 1) {
    scale *= 10;
    uiScale *= 10;
  }
  return uiScale;
};
